import React, { useCallback } from 'react';
import styled from 'styled-components';
import { SelectOption } from 'component-library-and-tools';

import Select from 'shared/components/Select';
import { Source } from 'shared/types/source';

import { SourceWeightCellProps } from './types';

const SELECT_TYPE_OPTIONS = [
  { name: '1' },
  { name: '2' },
  { name: '3' },
  { name: '4' },
  { name: '5' },
];

const StyledContainer = styled.div``;

const StyledSelect = styled(Select)`
  padding: 0.666666667rem 1rem;
  line-height: 1;
  font-size: 1rem;
`;

const handleSelect = (
  selectedWeight: SelectOption,
  source: Source,
  selectedSources: Source[],
  onChange: (value: any, fieldName?: string) => void,
) => {
  const updatedSources = selectedSources.map((selectedSource) => {
    if (selectedSource.id === source.id) {
      return {
        ...source,
        weight: +selectedWeight.name,
      };
    }

    return selectedSource;
  });

  onChange(updatedSources);
};

const getDefaultWeightOption = (source: Source) => (
  SELECT_TYPE_OPTIONS.filter((option) => +option.name === source.weight)
);

const SourceWeightCell = ({
  value: source,
  selectedSources = [],
  onChange,
}: SourceWeightCellProps) => {
  const isSelected = !!selectedSources.find(({ id }) => id === source.id);

  // This handler is just to prevent the click event from propagating to the table row
  // and deselecting it.
  const handleContainerClick = useCallback((event) => {
    event.stopPropagation();
  }, []);

  return (
    <StyledContainer onClick={handleContainerClick}>
      {isSelected && (
        <StyledSelect
          menuGap={4}
          defaultOptions={getDefaultWeightOption(source)}
          options={SELECT_TYPE_OPTIONS}
          onSelect={(selectedWeight) => (
            // TODO: This is temporary until we add generics in the `Select` component.
            handleSelect(selectedWeight as SelectOption, source, selectedSources, onChange)
          )}
        />
      )}
    </StyledContainer>
  );
};

export default SourceWeightCell;
